export default {
  onboardingData: {},
  onboardingDataLoading: false,
  onboardingUpdateLoading: false,
  onboardingSuccessMessage: null,

  treeUsageTutorial: null,
};
